export default __webpack_public_path__ + "dc8d2bf9b80d7f9bc33e41f97932b91c.jpg";